require("core-js/modules/es6.object.assign");

var _require = require('querystring'),
    parse = _require.parse,
    stringify = _require.stringify;

var qsMerge = function qsMerge(b) {
  return function (a) {
    return stringify(Object.assign({}, typeof a === "string" ? parse(a) : a, typeof b === "string" ? parse(b) : b));
  };
};

module.exports = qsMerge;